<template>
    <gsc-invoice-common></gsc-invoice-common>
</template>
<script>
import gscInvoiceCommon from './gscInvoiceCommon'
export default {
    name: 'gscInvoiceDetail',
    components: {
        gscInvoiceCommon
    }
}
</script>